var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _DuoyunTableElement_selectionSet, _DuoyunTableElement_onSelectionBoxChange, _DuoyunTableElement_onItemClick, _DuoyunTableElement_onItemContextMenu, _DuoyunTableElement_openActions, _DuoyunTableElement_shouldRenderTd, _DuoyunTableElement_getSpan, _DuoyunTableElement_expandedMap, _DuoyunTableElement_getKey, _DuoyunTableElement_toggleExpand, _DuoyunTableElement_iconColWidth, _DuoyunTableElement_expandedColumn, _DuoyunTableElement_getDefaultStyle;
var DuoyunTableElement_1;
// TODO: fixed row/column
import { connectStore, adoptedStyle, customElement, attribute, emitter, property, boolattribute, part, } from '@mantou/gem/lib/decorators';
import { GemElement, html } from '@mantou/gem/lib/element';
import { createCSSSheet, css, styleMap, classMap, isArrayChange } from '@mantou/gem/lib/utils';
import { theme } from '../lib/theme';
import { readProp } from '../lib/utils';
import { isNullish } from '../lib/types';
import { icons } from '../lib/icons';
import { commonHandle } from '../lib/hotkeys';
import { focusStyle } from '../lib/styles';
import { DuoyunUseElement } from './use';
import { ContextMenu } from './menu';
import './placeholder';
import './empty';
import './tooltip';
import './loading';
import './space';
import './selection-box';
const style = createCSSSheet(css `
  :host {
    display: block;
    overflow: auto;
    font-size: 0.875em;
    font-variant-numeric: tabular-nums;
    border-radius: ${theme.normalRound};
  }
  :host([hidden]) {
    display: none;
  }
  table {
    cursor: default;
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
  }
  .selection:where(:--select, [data-select]) ~ table {
    user-select: none;
  }
  .selection ~ table {
    cursor: crosshair;
  }
  thead {
    text-align: -webkit-match-parent;
    text-align: -moz-match-parent;
    text-align: match-parent;
  }
  th {
    font-weight: bold;
  }
  tr {
    border-block-end: 1px solid ${theme.borderColor};
  }
  tbody tr:hover {
    background-color: ${theme.lightBackgroundColor};
  }
  td {
    position: relative;
  }
  tr.selected td::after {
    position: absolute;
    display: block;
    content: '';
    top: 0px;
    left: 0px;
    width: 100%;
    height: calc(100% + 1px);
    opacity: 0.15;
    background-color: ${theme.informativeColor};
  }
  td.ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  td.placeholder {
    pointer-events: none;
  }
  th,
  td {
    padding: 0.8em 0.5em;
  }
  .tooltip {
    width: 1em;
  }
  .action {
    cursor: default;
    width: 1.5em;
    padding: 4px;
    border-radius: ${theme.normalRound};
  }
  .action:where(:hover, :--active, [data-active]) {
    background-color: ${theme.hoverBackgroundColor};
  }
  .side {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20em;
  }
`);
/**
 * @customElement dy-table
 */
let DuoyunTableElement = DuoyunTableElement_1 = class DuoyunTableElement extends GemElement {
    constructor() {
        super(...arguments);
        _DuoyunTableElement_selectionSet.set(this, new Set());
        _DuoyunTableElement_onSelectionBoxChange.set(this, ({ detail: { rect, mode } }) => {
            const selection = new Set(mode === 'new' ? [] : __classPrivateFieldGet(this, _DuoyunTableElement_selectionSet, "f"));
            const boxWidth = rect.width;
            const boxHeight = rect.height;
            const boxBottom = rect.bottom;
            const boxRight = rect.right;
            const boxLeft = rect.left;
            const boxTop = rect.top;
            const rects = [...this.shadowRoot.querySelectorAll('tbody tr')].map((e) => e.getBoundingClientRect());
            rects.forEach(({ width, height, bottom, top, left, right }, i) => {
                // rowspan?
                if (Math.max(bottom, boxBottom) - Math.min(top, boxTop) < boxHeight + height &&
                    Math.max(right, boxRight) - Math.min(left, boxLeft) < boxWidth + width) {
                    const item = __classPrivateFieldGet(this, _DuoyunTableElement_getKey, "f").call(this, this.data[i]);
                    if (mode === 'delete') {
                        selection.delete(item);
                    }
                    else {
                        selection.add(item);
                    }
                }
            });
            const selectionArr = [...selection];
            if (isArrayChange(this.selection || [], selectionArr)) {
                this.select(selectionArr);
            }
        });
        _DuoyunTableElement_onItemClick.set(this, (record) => {
            if (__classPrivateFieldGet(this, _DuoyunTableElement_selectionSet, "f").size) {
                const item = __classPrivateFieldGet(this, _DuoyunTableElement_getKey, "f").call(this, record);
                const selection = new Set(__classPrivateFieldGet(this, _DuoyunTableElement_selectionSet, "f"));
                if (__classPrivateFieldGet(this, _DuoyunTableElement_selectionSet, "f").has(item)) {
                    selection.delete(item);
                }
                else {
                    selection.add(item);
                }
                this.select([...selection]);
            }
            else {
                this.itemclick(record);
            }
        });
        _DuoyunTableElement_onItemContextMenu.set(this, (evt, record) => {
            this.itemcontextmenu({
                data: record,
                originEvent: evt,
                selected: __classPrivateFieldGet(this, _DuoyunTableElement_selectionSet, "f").has(__classPrivateFieldGet(this, _DuoyunTableElement_getKey, "f").call(this, record)),
            });
        });
        _DuoyunTableElement_openActions.set(this, (evt, menu) => {
            if (evt.target instanceof DuoyunUseElement) {
                ContextMenu.open(menu, {
                    activeElement: evt.target,
                    searchable: menu.length > 20,
                    maxHeight: '30em',
                });
            }
        });
        _DuoyunTableElement_shouldRenderTd.set(this, (spanMemo, index) => {
            if (spanMemo[index]) {
                spanMemo[index]--;
                return false;
            }
            return true;
        });
        _DuoyunTableElement_getSpan.set(this, (spanMemo, index, span) => {
            if (isNullish(span)) {
                return 1;
            }
            spanMemo[index] = span - 1;
            return span;
        });
        _DuoyunTableElement_expandedMap.set(this, new Map());
        _DuoyunTableElement_getKey.set(this, (record) => (this.rowKey ? readProp(record, this.rowKey) : record));
        _DuoyunTableElement_toggleExpand.set(this, (record) => {
            const key = __classPrivateFieldGet(this, _DuoyunTableElement_getKey, "f").call(this, record);
            const expanded = !!__classPrivateFieldGet(this, _DuoyunTableElement_expandedMap, "f").get(key);
            __classPrivateFieldGet(this, _DuoyunTableElement_expandedMap, "f").set(key, !expanded);
            if (!expanded)
                this.expand(record);
            this.update();
        });
        _DuoyunTableElement_iconColWidth.set(this, '50px');
        _DuoyunTableElement_expandedColumn.set(this, {
            title: '',
            width: __classPrivateFieldGet(this, _DuoyunTableElement_iconColWidth, "f"),
            render: (record) => html `
        <dy-use
          class="action"
          @click=${() => __classPrivateFieldGet(this, _DuoyunTableElement_toggleExpand, "f").call(this, record)}
          .element=${__classPrivateFieldGet(this, _DuoyunTableElement_expandedMap, "f").get(__classPrivateFieldGet(this, _DuoyunTableElement_getKey, "f").call(this, record)) ? icons.expand : icons.right}
        ></dy-use>
      `,
        });
        _DuoyunTableElement_getDefaultStyle.set(this, (width) => {
            return (width === null || width === void 0 ? void 0 : width.startsWith('0')) ? { fontSize: '0' } : {};
        });
        this.mounted = () => {
            this.memo(() => {
                __classPrivateFieldSet(this, _DuoyunTableElement_selectionSet, new Set(this.selection), "f");
            }, () => this.selection || []);
        };
        this.render = () => {
            var _a;
            const columns = this.expandedRowRender ? [__classPrivateFieldGet(this, _DuoyunTableElement_expandedColumn, "f"), ...this.columns] : this.columns;
            const rowSpanMemo = columns.map(() => 0);
            return html `
      ${this.selectable
                ? html `<dy-selection-box class="selection" @change=${__classPrivateFieldGet(this, _DuoyunTableElement_onSelectionBoxChange, "f")}></dy-selection-box>`
                : ''}
      <table part=${DuoyunTableElement_1.table}>
        ${this.caption
                ? html `
              <caption>
                ${this.caption}
              </caption>
            `
                : ''}
        <colgroup>
          ${columns.map(({ width = 'auto', render, getActions }) => html `<col style=${styleMap({ width: !render && getActions ? __classPrivateFieldGet(this, _DuoyunTableElement_iconColWidth, "f") : width })}></col>`)}
        </colgroup>
        ${this.headless
                ? ''
                : html `
              <thead>
                <tr>
                  ${columns.map(({ title = '', width, style = __classPrivateFieldGet(this, _DuoyunTableElement_getDefaultStyle, "f").call(this, width), tooltip }) => html `
                      <th part=${DuoyunTableElement_1.th} style=${styleMap(style)}>
                        <dy-space size="small">
                          ${title}
                          ${tooltip
                    ? html `
                                <dy-tooltip .content=${tooltip}>
                                  <dy-use class="tooltip" .element=${icons.help}></dy-use>
                                </dy-tooltip>
                              `
                    : ''}
                        </dy-space>
                      </th>
                    `)}
                </tr>
              </thead>
            `}
        <tbody>
          ${(_a = this.data) === null || _a === void 0 ? void 0 : _a.map((record, _rowIndex, _data, colSpanMemo = [0]) => html `
                <tr
                  @click=${() => __classPrivateFieldGet(this, _DuoyunTableElement_onItemClick, "f").call(this, record)}
                  @contextmenu=${(evt) => __classPrivateFieldGet(this, _DuoyunTableElement_onItemContextMenu, "f").call(this, evt, record)}
                  part=${DuoyunTableElement_1.tr}
                  class=${classMap({ selected: __classPrivateFieldGet(this, _DuoyunTableElement_selectionSet, "f").has(__classPrivateFieldGet(this, _DuoyunTableElement_getKey, "f").call(this, record)) })}
                  style=${this.getRowStyle ? styleMap(this.getRowStyle(record)) : ''}
                >
                  ${columns.map(({ dataIndex, render, getActions, width, style = __classPrivateFieldGet(this, _DuoyunTableElement_getDefaultStyle, "f").call(this, width), getRowspan, getColspan, ellipsis = false, }, colIndex, _arr, rowShouldRender = __classPrivateFieldGet(this, _DuoyunTableElement_shouldRenderTd, "f").call(this, rowSpanMemo, colIndex), rowSpan = rowShouldRender
                ? __classPrivateFieldGet(this, _DuoyunTableElement_getSpan, "f").call(this, rowSpanMemo, colIndex, getRowspan === null || getRowspan === void 0 ? void 0 : getRowspan(record, this.data))
                : 1, colShouldRender = __classPrivateFieldGet(this, _DuoyunTableElement_shouldRenderTd, "f").call(this, colSpanMemo, 0), colSpan = colShouldRender ? __classPrivateFieldGet(this, _DuoyunTableElement_getSpan, "f").call(this, colSpanMemo, 0, getColspan === null || getColspan === void 0 ? void 0 : getColspan(record, this.data)) : 1) => rowShouldRender && colShouldRender
                ? html `
                            <td
                              class=${classMap({ placeholder: !record, ellipsis })}
                              style=${styleMap(style)}
                              part=${DuoyunTableElement_1.td}
                              rowspan=${rowSpan}
                              colspan=${colSpan}
                            >
                              ${!record
                    ? html `<dy-placeholder ?center=${style.textAlign === 'center'}></dy-placeholder>`
                    : render
                        ? render(record)
                        : getActions
                            ? html `
                                    <dy-use
                                      class="action"
                                      tabindex="0"
                                      role="button"
                                      aria-label="Actions"
                                      .element=${icons.more}
                                      @keydown=${commonHandle}
                                      @click=${(evt) => __classPrivateFieldGet(this, _DuoyunTableElement_openActions, "f").call(this, evt, getActions(record, evt.target))}
                                    ></dy-use>
                                  `
                            : dataIndex
                                ? readProp(record, dataIndex)
                                : ''}
                            </td>
                          `
                : '')}
                </tr>
                ${this.expandedRowRender && __classPrivateFieldGet(this, _DuoyunTableElement_expandedMap, "f").get(__classPrivateFieldGet(this, _DuoyunTableElement_getKey, "f").call(this, record))
                ? html `
                      <tr>
                        <td style=${styleMap({ padding: `0 0 0 ${__classPrivateFieldGet(this, _DuoyunTableElement_iconColWidth, "f")}` })} colspan=${columns.length}>
                          ${this.expandedRowRender(record) || html `<dy-loading></dy-loading>`}
                        </td>
                      </tr>
                    `
                : ''}
              `)}
        </tbody>
      </table>
      ${!this.data
                ? html `<div class="side" part=${DuoyunTableElement_1.side}><dy-loading></dy-loading></div>`
                : this.data.length === 0
                    ? html `<div class="side" part=${DuoyunTableElement_1.side}>${this.noData || html `<dy-empty></dy-empty>`}</div>`
                    : ''}
    `;
        };
    }
    appendSelection(items) {
        const selection = new Set(__classPrivateFieldGet(this, _DuoyunTableElement_selectionSet, "f"));
        items.forEach((item) => selection.add(__classPrivateFieldGet(this, _DuoyunTableElement_getKey, "f").call(this, item)));
        this.select([...selection]);
    }
    removeSelection(items) {
        const selection = new Set(__classPrivateFieldGet(this, _DuoyunTableElement_selectionSet, "f"));
        items.forEach((item) => selection.delete(__classPrivateFieldGet(this, _DuoyunTableElement_getKey, "f").call(this, item)));
        this.select([...selection]);
    }
};
_DuoyunTableElement_selectionSet = new WeakMap(), _DuoyunTableElement_onSelectionBoxChange = new WeakMap(), _DuoyunTableElement_onItemClick = new WeakMap(), _DuoyunTableElement_onItemContextMenu = new WeakMap(), _DuoyunTableElement_openActions = new WeakMap(), _DuoyunTableElement_shouldRenderTd = new WeakMap(), _DuoyunTableElement_getSpan = new WeakMap(), _DuoyunTableElement_expandedMap = new WeakMap(), _DuoyunTableElement_getKey = new WeakMap(), _DuoyunTableElement_toggleExpand = new WeakMap(), _DuoyunTableElement_iconColWidth = new WeakMap(), _DuoyunTableElement_expandedColumn = new WeakMap(), _DuoyunTableElement_getDefaultStyle = new WeakMap();
__decorate([
    attribute
], DuoyunTableElement.prototype, "caption", void 0);
__decorate([
    boolattribute
], DuoyunTableElement.prototype, "headless", void 0);
__decorate([
    boolattribute
], DuoyunTableElement.prototype, "selectable", void 0);
__decorate([
    property
], DuoyunTableElement.prototype, "selection", void 0);
__decorate([
    emitter
], DuoyunTableElement.prototype, "select", void 0);
__decorate([
    emitter
], DuoyunTableElement.prototype, "itemclick", void 0);
__decorate([
    emitter
], DuoyunTableElement.prototype, "itemcontextmenu", void 0);
__decorate([
    property
], DuoyunTableElement.prototype, "columns", void 0);
__decorate([
    property
], DuoyunTableElement.prototype, "data", void 0);
__decorate([
    property
], DuoyunTableElement.prototype, "getRowStyle", void 0);
__decorate([
    property
], DuoyunTableElement.prototype, "noData", void 0);
__decorate([
    property
], DuoyunTableElement.prototype, "rowKey", void 0);
__decorate([
    property
], DuoyunTableElement.prototype, "expandedRowRender", void 0);
__decorate([
    emitter
], DuoyunTableElement.prototype, "expand", void 0);
__decorate([
    part
], DuoyunTableElement, "table", void 0);
__decorate([
    part
], DuoyunTableElement, "th", void 0);
__decorate([
    part
], DuoyunTableElement, "td", void 0);
__decorate([
    part
], DuoyunTableElement, "tr", void 0);
__decorate([
    part
], DuoyunTableElement, "side", void 0);
DuoyunTableElement = DuoyunTableElement_1 = __decorate([
    customElement('dy-table'),
    adoptedStyle(style),
    adoptedStyle(focusStyle),
    connectStore(icons)
], DuoyunTableElement);
export { DuoyunTableElement };
//# sourceMappingURL=table.js.map